import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import StepList from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/";
function StepListFormik({ field, onMoveList = void 0, onViewStep = void 0, onRemoveStep = void 0 }) {
  const [{ value }, _meta, { setValue, setTouched }] = useField({ name: field.name });
  const handleMoveList = useCallback(
    (newList) => {
      setValue(newList);
      setTouched(true);
      onMoveList == null ? void 0 : onMoveList(newList);
    },
    [setValue, setTouched, onMoveList]
  );
  const handleRemoveStep = useCallback(
    (stepId) => {
      value.filter((step) => step.id !== stepId);
      onRemoveStep == null ? void 0 : onRemoveStep(stepId);
    },
    [onRemoveStep, value]
  );
  return /* @__PURE__ */ React.createElement(StepList, { steps: value, onMoveList: handleMoveList, onViewStep, onRemoveStep: handleRemoveStep });
}
export default StepListFormik;
